import { connect } from 'react-redux'
import { createSelector } from 'reselect'

import {
  getRecycleBinItemsDeletedByMe,
  getLoadingRecycleBinItemsDeletedByMe,
  getRecycleBinItemsDeletedByMeOffset,
  getRecycleBinItemsDeletedByMeLimit,
  getRecycleBinItemsDeletedByMeTotalCount,
  getRestoringRecycleBinItemsDeletedByMe
} from '../state'

import RecycleBinItemsDeletedByMe from '../components/RecycleBinItemsDeletedByMe'

const mapStateToProps = createSelector(
  [
    getRecycleBinItemsDeletedByMe,
    getLoadingRecycleBinItemsDeletedByMe,
    getRecycleBinItemsDeletedByMeOffset,
    getRecycleBinItemsDeletedByMeLimit,
    getRecycleBinItemsDeletedByMeTotalCount,
    getRestoringRecycleBinItemsDeletedByMe
  ],
  (data, loadingContent, offset, limit, totalCount, restoring) => ({
    data,
    loading: loadingContent || restoring,
    offset,
    limit,
    totalCount
  })
)

export default connect(mapStateToProps)(RecycleBinItemsDeletedByMe as any)
